import React from 'react';
import clsx from 'clsx';
//DS
import {helpers} from 'lib.front';
//Navegacion
//Material-UI
//Componentes
import makeStyles from '@material-ui/core/styles/makeStyles';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

//Iconos
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import Item from '../Item';

const useStyles = makeStyles(theme => ({
   root: {}
}));

const SidebarNav = props => {
   const classes = useStyles();
   //Estados
   const [open, setOpen] = React.useState(false);
   //Handlers
   function handleClick() {
      setOpen(!open);
   }

   const {className, ...rest} = props;

   return (
      <List {...rest} className={clsx(classes.root, className)}>
         <ListItem button onClick={handleClick}>
            <ListItemIcon>{props.icon}</ListItemIcon>
            <ListItemText primary={props.title} />
            {open ? <ExpandLess /> : <ExpandMore />}
         </ListItem>
         <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
               {props.pages.map(item => (
                  <Item
                     key={item.title}
                     href={item.href}
                     title={item.title}
                     icon={item.icon}
                     hidden={helpers.hidden(item)}
                  />
               ))}
            </List>
         </Collapse>
      </List>
   );
};

export default SidebarNav;
